import AuthGuard from '@/auth/main/route-guard/AuthGuard';
import Layout from '@/common/presentation/components/layout/Layout';
import HomeRoutes from '@/home/main/HomeRoutes';
import PaymentHistoryRoutes from '@/payment-history/main/PaymentHistoryRoutes';
import SelectedInvoicesRoutes from '@/shopping-cart/main/SelectedInvoicesRoutes';
import Loadable from '@/common/presentation/components/utils/Loader/Loadable';
import { lazy } from 'react';

const HomePage = Loadable(lazy(() => import('@/home/presentation/pages/HomePage')));

const MainRaptorRoutes = [
  {
    index: true,
    element: <HomePage />,
  },
  HomeRoutes,
  PaymentHistoryRoutes,
  SelectedInvoicesRoutes,
];

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <Layout />
    </AuthGuard>
  ),
  children: [...MainRaptorRoutes],
};

export default MainRoutes;
